export const pricing = {
  hero: {
    heading: {
      serve: 'Serve',
      more_orders: 'more orders',
      to_your_restaurant: 'to your restaurant with Bistroo',
    },
    saving_time: 'We\'re saving time and increase your profit.',
    boosting_business: 'We\'re boosting your online business.',
  },

  plans: {
    free: {
      title: 'Gratis',
      price: '€ 0',
      period: '/ maand',
      subtitle: 'Webshop of website',
      description: 'Voor restauranthouders die op zoek zijn naar een vrij- blijvende oplossing',
      enabledFeatures: [
        'Webshop',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Kortingen & promoties',
        'Basic reporting',
      ],
      start: 'Start nu'
    },
    starter: {
      title: 'Starter',
      price: '€ 39',
      period: '/ maand',
      subtitle: 'Webshop of QR',
      description: 'Een op maat gemaakte web- of QR-shop op basis van een vaste prijs',
      enabledFeatures: [
        'Webshop or QR order',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Kortingen & promoties',
        'Basic reporting',
        'Integraties (POS etc.)',
        'Printer support'
      ],
      start: 'Probeer gratis'
    },
    professional: {
      title: 'Professional',
      price: '€ 49',
      period: '/ maand',
      subtitle: 'Webshop en website',
      description: 'Voor restauranthouders die op zoek zijn naar een professionele website',
      enabledFeatures: [
        'Webshop',
        'Website',
        'Custom brand styling',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Kortingen & promoties',
        'Advanced reporting',
        'QR ordering module',
        'Integraties (POS etc.)',
        'Printer support'
      ],
      start: 'Probeer gratis'
    },
    enterprise: {
      title: 'Enterprise',
      price: 'Custom',
      period: 'prijs',
      subtitle: 'Stel je pakket samen',
      description: 'Voor ondernemers die behoefte hebben aan maatwerk',
      enabledFeatures: [
        'Custom webshop',
        'Custom website',
        'Custom brand styling',
        'Volledige premium options',
        'Team & gebruikers beheer',
        'Order management',
        'Sales insights',
        'Menu builder',
        'Product configurator',
        'Kortingen & promoties',
        'Advanced reporting',
        'QR ordering module',
        'Integraties (POS etc.)',
        'Printer support',
      ],
      start: 'Neem contact op'
    },
  },

  compare: 'Vergelijk alle features hieronder',

  closer_look: {
    title: 'Een gedetailleerd overzicht van elk pakket',
    description: {
      1: 'Of je nu net begint of snel groeit, wij hebben de functies om jouw online business een boost te geven.',
      2: 'Ontdek onze flexibele SaaS-pakketten die met je mee groeien.'
    }
  },

  table: {
    row_1: {
      title: 'Base package',
      value_1: 'Webshop',
      value_2: 'Webshop or QR',
      value_3: 'Website & webshop or QR',
      value_4: 'Website, webshop & QR'
    }
  }
}